"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WingerRoleBonuses = exports.WingerExpandedRoles = void 0;
// wingerRoles.ts
const playerBonuses_1 = require("../playerBonuses");
const playerTraits_1 = require("../playerTraits");
const rarity_1 = require("../rarity");
const zones_1 = require("../zones");
const baseRoles_1 = require("./baseRoles");
var WingerExpandedRoles;
(function (WingerExpandedRoles) {
    // --- Uncommon --- GENERIC (Consistent with AM/Striker)
    WingerExpandedRoles["RAPID_WINGER"] = "RAPID_WINGER";
    WingerExpandedRoles["POWERFUL_WINGER"] = "POWERFUL_WINGER";
    WingerExpandedRoles["TIRELESS_WINGER"] = "TIRELESS_WINGER";
    WingerExpandedRoles["DETERMINED_WINGER"] = "DETERMINED_WINGER";
    WingerExpandedRoles["HEROIC_WINGER"] = "HEROIC_WINGER";
    WingerExpandedRoles["ECCENTRIC_WINGER"] = "ECCENTRIC_WINGER";
    WingerExpandedRoles["RELIABLE_WINGER"] = "RELIABLE_WINGER";
    WingerExpandedRoles["LUCKY_WINGER"] = "LUCKY_WINGER";
    WingerExpandedRoles["TENACIOUS_WINGER"] = "TENACIOUS_WINGER";
    WingerExpandedRoles["INSPIRATIONAL_WINGER"] = "INSPIRATIONAL_WINGER";
    WingerExpandedRoles["DOMINANT_WINGER"] = "DOMINANT_WINGER";
    WingerExpandedRoles["IMPACT_WINGER"] = "IMPACT_WINGER";
    WingerExpandedRoles["PRESSING_WINGER"] = "PRESSING_WINGER";
    WingerExpandedRoles["VOCAL_WINGER"] = "VOCAL_WINGER";
    WingerExpandedRoles["EXPERIENCED_WINGER"] = "EXPERIENCED_WINGER";
    WingerExpandedRoles["FIREY_WINGER"] = "FIREY_WINGER";
    WingerExpandedRoles["VERSATILE_WINGER"] = "VERSATILE_WINGER";
    // --- Uncommon --- WINGER SPECIFIC / ATTACKING FOCUS
    WingerExpandedRoles["STAR_WINGER"] = "STAR_WINGER";
    WingerExpandedRoles["SILKY_WINGER"] = "SILKY_WINGER";
    WingerExpandedRoles["PENETRATING_WINGER"] = "PENETRATING_WINGER";
    WingerExpandedRoles["PLAYMAKING_WINGER"] = "PLAYMAKING_WINGER";
    WingerExpandedRoles["LETHAL_WINGER"] = "LETHAL_WINGER";
    WingerExpandedRoles["ROAMING_WINGER"] = "ROAMING_WINGER";
    WingerExpandedRoles["ORCHESTRATING_WINGER"] = "ORCHESTRATING_WINGER";
    WingerExpandedRoles["WIDE_OUTLET"] = "WIDE_OUTLET";
    // --- Rare --- GENERIC COMBINATIONS (Two basic traits)
    WingerExpandedRoles["ATHLETIC_WINGER"] = "ATHLETIC_WINGER";
    WingerExpandedRoles["ENERGETIC_WINGER"] = "ENERGETIC_WINGER";
    WingerExpandedRoles["VALIANT_WINGER"] = "VALIANT_WINGER";
    WingerExpandedRoles["PLUCKY_WINGER"] = "PLUCKY_WINGER";
    WingerExpandedRoles["GEGEN_PRESSING_WINGER"] = "GEGEN_PRESSING_WINGER";
    WingerExpandedRoles["COMMANDING_WINGER"] = "COMMANDING_WINGER";
    WingerExpandedRoles["ROUSING_WINGER"] = "ROUSING_WINGER";
    // --- Rare --- ARCHETYPAL WINGERS (Combining specific winger functions or styles)
    WingerExpandedRoles["INSIDE_FORWARD"] = "INSIDE_FORWARD";
    WingerExpandedRoles["ELUSIVE_WINGER"] = "ELUSIVE_WINGER";
    WingerExpandedRoles["CLASSIC_WINGER"] = "CLASSIC_WINGER";
    WingerExpandedRoles["CREATIVE_WINGER"] = "CREATIVE_WINGER";
    WingerExpandedRoles["FLYING_WINGER"] = "FLYING_WINGER";
    WingerExpandedRoles["INVERTED_PLAYMAKER"] = "INVERTED_PLAYMAKER";
})(WingerExpandedRoles || (exports.WingerExpandedRoles = WingerExpandedRoles = {}));
exports.WingerRoleBonuses = {
    [baseRoles_1.BaseRoles.WINGER]: {
        rarity: rarity_1.Rarity.COMMON,
        statBlock: {
            run: playerBonuses_1.PlayerBonuses.MAIN_POSITION_ATTRIBUTE,
            pass: playerBonuses_1.PlayerBonuses.SECOND_POSITION_ATTRIBUTE,
            shoot: playerBonuses_1.PlayerBonuses.THIRD_POSITION_ATTRIBUTE,
        },
        positionsEnabled: [zones_1.Zones.MIDFIELD, zones_1.Zones.ATTACK], // Wingers can operate in MF or ATT
        playerTraits: [],
    },
    // --- Uncommon --- GENERIC ---
    [WingerExpandedRoles.RAPID_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RAPID],
    },
    [WingerExpandedRoles.POWERFUL_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Powerful runs
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.POWERFUL],
    },
    [WingerExpandedRoles.TIRELESS_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Stamina for covering flank/pressing
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAMINA],
    },
    [WingerExpandedRoles.DETERMINED_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Determined runs/efforts
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DETERMINED],
    },
    [WingerExpandedRoles.HEROIC_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Heroic cross or assist
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HERO],
    },
    [WingerExpandedRoles.ECCENTRIC_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Flair for dribbling
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FLAIR],
    },
    [WingerExpandedRoles.RELIABLE_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Reliable delivery
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.RELIABLE],
    },
    [WingerExpandedRoles.LUCKY_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Lucky cross/bounce for an assist
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LUCKY],
    },
    [WingerExpandedRoles.TENACIOUS_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Hard work, tracking back, pressing runs
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.UNDERDOG],
    },
    [WingerExpandedRoles.INSPIRATIONAL_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring play, assist
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.INSPIRE],
    },
    [WingerExpandedRoles.DOMINANT_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Dominating the flank with runs
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.DOMINANT],
    },
    [WingerExpandedRoles.IMPACT_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Sub coming on to add pace/directness
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SUPER_SUB],
    },
    [WingerExpandedRoles.PRESSING_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Key stat for pressing effectively
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PRESSING], // Assuming PlayerTraits.PRESSING exists
    },
    [WingerExpandedRoles.VOCAL_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Organising attack from wide/directing passes
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.ORGANISED],
    },
    [WingerExpandedRoles.EXPERIENCED_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise decision making in wide areas (passing/crossing)
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.WISE],
    },
    [WingerExpandedRoles.FIREY_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Ignite and tackling boost
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.IGNITE],
    },
    [WingerExpandedRoles.VERSATILE_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Boost to 3rd position attribute (shoot)
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.VERSATILE],
    },
    // --- Uncommon --- WINGER SPECIFIC / ATTACKING FOCUS ---
    [WingerExpandedRoles.STAR_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Star wingers often have goal threat
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.STAR],
    },
    [WingerExpandedRoles.SILKY_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Good touch for dribbling
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.FIRST_TOUCH],
    },
    [WingerExpandedRoles.PENETRATING_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.CHARGE],
    },
    [WingerExpandedRoles.PLAYMAKING_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.PLAYMAKER],
    },
    [WingerExpandedRoles.LETHAL_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.LETHAL],
    },
    [WingerExpandedRoles.ROAMING_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Movement into half-spaces
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.HALF_SPACES],
    },
    [WingerExpandedRoles.ORCHESTRATING_WINGER]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.SHORT_PASS],
    },
    [WingerExpandedRoles.WIDE_OUTLET]: {
        parentRoles: [baseRoles_1.BaseRoles.WINGER],
        rarity: rarity_1.Rarity.UNCOMMON,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Receiving long balls and linking play
        positionsEnabled: [],
        playerTraits: [playerTraits_1.PlayerTraits.TARGET],
    },
    // --- Rare --- GENERIC COMBINATIONS ---
    [WingerExpandedRoles.ATHLETIC_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.RAPID_WINGER,
            WingerExpandedRoles.POWERFUL_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.ENERGETIC_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.RAPID_WINGER,
            WingerExpandedRoles.TIRELESS_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.VALIANT_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.DETERMINED_WINGER,
            WingerExpandedRoles.HEROIC_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Valiant effort leading to a key pass/cross
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.PLUCKY_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.LUCKY_WINGER,
            WingerExpandedRoles.TENACIOUS_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Plucky effort runs
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.GEGEN_PRESSING_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.ORCHESTRATING_WINGER,
            WingerExpandedRoles.PRESSING_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { tackle: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Pressing aspect more dominant for stat
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.COMMANDING_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.EXPERIENCED_WINGER,
            WingerExpandedRoles.VOCAL_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Wise and organised playmaking from wide
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.ROUSING_WINGER]: {
        parentRoles: [
            WingerExpandedRoles.INSPIRATIONAL_WINGER,
            WingerExpandedRoles.DETERMINED_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Inspiring teammates through control/passing
        positionsEnabled: [],
        playerTraits: [],
    },
    // --- Rare --- ARCHETYPAL WINGERS ---
    [WingerExpandedRoles.INSIDE_FORWARD]: {
        // Charge (Penetrating) + Lethal
        parentRoles: [
            WingerExpandedRoles.PENETRATING_WINGER,
            WingerExpandedRoles.LETHAL_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { shoot: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Primary function is to score
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.CLASSIC_WINGER]: {
        // Rapid + Playmaker
        parentRoles: [
            WingerExpandedRoles.RAPID_WINGER,
            WingerExpandedRoles.PLAYMAKING_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE }, // Emphasizing pace of classic wing play
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.CREATIVE_WINGER]: {
        // Silky Winger + Playmaking Winger
        parentRoles: [
            WingerExpandedRoles.SILKY_WINGER,
            WingerExpandedRoles.PLAYMAKING_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.FLYING_WINGER]: {
        // Rapid + Flair (Eccentric)
        parentRoles: [
            WingerExpandedRoles.RAPID_WINGER,
            WingerExpandedRoles.ECCENTRIC_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.INVERTED_PLAYMAKER]: {
        // Roaming Winger + Playmaking Winger
        parentRoles: [
            WingerExpandedRoles.ROAMING_WINGER,
            WingerExpandedRoles.PLAYMAKING_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { pass: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
    [WingerExpandedRoles.ELUSIVE_WINGER]: {
        // Flair + Charge
        parentRoles: [
            WingerExpandedRoles.ECCENTRIC_WINGER,
            WingerExpandedRoles.PENETRATING_WINGER,
        ],
        rarity: rarity_1.Rarity.RARE,
        statBlock: { run: playerBonuses_1.PlayerBonuses.ROLE_INCREASE_ATTRIBUTE },
        positionsEnabled: [],
        playerTraits: [],
    },
};
